import { HttpInterceptorFn } from '@angular/common/http';
import {inject} from '@angular/core';
import {AuthenticationService} from './authentication.service';
import {tap} from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const authToken = authService.getToken();

  if (req.url.includes('login')) {
    return next(req);
  }

  const newReq = req.clone({
    headers: authToken ? req.headers.append('Authorization', 'Bearer '+authToken) : undefined,
  });

  return next(newReq).pipe(
    tap({
      error: (err) => {
        if (err.status === 401) {
          authService.logoutAndRedirect();
        }
      }
    })
  );
};
